import { gql } from '@apollo/client';

export default gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      __typename
      ... on User {
        token
        id
        email
        distributorName
        phoneNumber
        firstname
        lastname
        isAdmin
      }
    }
  }
`;
